/**
 * @generated SignedSource<<e19e53d820fdfb722f877b1c81bd7903>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrgFeatures = "ANALYTICS" | "FILES" | "MAP" | "PRODUCTS" | "ROUTINES" | "SIGNALS" | "SPACES" | "TODOS";
export type WorkspaceSignalStatus = "ARCHIVED" | "DRAFT" | "PUBLISHED" | "SCHEDULED";
export type WorkspaceSignalEditMainQuery$variables = {
  createIfNotExist: boolean;
  id: string;
  workspaceId: string;
};
export type WorkspaceSignalEditMainQuery$data = {
  readonly organisation: {
    readonly features: ReadonlyArray<OrgFeatures>;
  } | null;
  readonly workspace: {
    readonly id: string;
    readonly signal: {
      readonly id: string;
      readonly potentialReceiverStores: ReadonlyArray<{
        readonly __typename: "ReceiverStore";
      }>;
      readonly receiverStores: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly scheduledPublishAt: {
        readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
      } | null;
      readonly status: WorkspaceSignalStatus;
      readonly " $fragmentSpreads": FragmentRefs<"SignalWorkspaceTemplateSelector_SignalWorkspace" | "WorkspaceRecieversListItemButton_workspaceEntity" | "WorkspaceSignalEditMainContent_Signal" | "WorkspaceSignalEditMainEditedInfo_Signal" | "WorkspaceSignalEditMainPrioritySelector_Signal" | "WorkspaceSignalEditMainProducts_Signal" | "WorkspaceSignalEditMainPushNotification_signalWorkspace">;
    };
    readonly " $fragmentSpreads": FragmentRefs<"SignalWorkspaceTemplateSelector_workspace">;
  };
};
export type WorkspaceSignalEditMainQuery = {
  response: WorkspaceSignalEditMainQuery$data;
  variables: WorkspaceSignalEditMainQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "createIfNotExist"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "features",
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "workspaceId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  {
    "kind": "Variable",
    "name": "createIfNotExist",
    "variableName": "createIfNotExist"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v7 = [
  (v5/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Store",
  "kind": "LinkedField",
  "name": "receiverStores",
  "plural": true,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v10 = [
  (v9/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v13 = [
  (v5/*: any*/),
  (v12/*: any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isoString",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbhash",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlExpiresAt",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceSignalEditMainQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Organisation",
        "kind": "LinkedField",
        "name": "organisation",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v4/*: any*/),
          "concreteType": "Workspace",
          "kind": "LinkedField",
          "name": "workspace",
          "plural": false,
          "selections": [
            (v5/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SignalWorkspaceTemplateSelector_workspace"
            },
            {
              "kind": "RequiredField",
              "field": {
                "alias": null,
                "args": (v6/*: any*/),
                "concreteType": "SignalWorkspace",
                "kind": "LinkedField",
                "name": "signal",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ReceiverStore",
                    "kind": "LinkedField",
                    "name": "potentialReceiverStores",
                    "plural": true,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnzonedDate",
                    "kind": "LinkedField",
                    "name": "scheduledPublishAt",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "FormattedDate"
                      }
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "SignalWorkspaceTemplateSelector_SignalWorkspace"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "WorkspaceSignalEditMainPrioritySelector_Signal"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "WorkspaceSignalEditMainEditedInfo_Signal"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "WorkspaceSignalEditMainContent_Signal"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "WorkspaceSignalEditMainProducts_Signal"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "WorkspaceSignalEditMainPushNotification_signalWorkspace"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "WorkspaceRecieversListItemButton_workspaceEntity"
                  }
                ],
                "storageKey": null
              },
              "action": "THROW"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WorkspaceSignalEditMainQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Organisation",
        "kind": "LinkedField",
        "name": "organisation",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SignalWorkspaceTemplate",
            "kind": "LinkedField",
            "name": "signalTemplates",
            "plural": true,
            "selections": (v13/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "SignalWorkspace",
            "kind": "LinkedField",
            "name": "signal",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ReceiverStore",
                "kind": "LinkedField",
                "name": "potentialReceiverStores",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "scheduledPublishAt",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v14/*: any*/)
                    ],
                    "type": "Date",
                    "abstractKey": "__isDate"
                  }
                ],
                "storageKey": null
              },
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "updatedBy",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v5/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "body",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "File",
                "kind": "LinkedField",
                "name": "descriptionFiles",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  (v5/*: any*/),
                  (v15/*: any*/),
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isOrg",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FilePage",
                    "kind": "LinkedField",
                    "name": "pages",
                    "plural": true,
                    "selections": (v7/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "thumbnail",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v16/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ImageSize",
                        "kind": "LinkedField",
                        "name": "sizes",
                        "plural": true,
                        "selections": [
                          (v5/*: any*/),
                          (v15/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "descriptionImages",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ImageSize",
                    "kind": "LinkedField",
                    "name": "sizes",
                    "plural": true,
                    "selections": [
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v5/*: any*/),
                      (v15/*: any*/),
                      (v17/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v16/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SignalWorkspaceTemplate",
                "kind": "LinkedField",
                "name": "template",
                "plural": false,
                "selections": (v13/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "priority",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "updatedAtDate",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isDate"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "formattedBody",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedBySessionId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "WorkspaceProduct",
                "kind": "LinkedField",
                "name": "linkedProducts",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "imageUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "partNumber",
                    "storageKey": null
                  },
                  (v12/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sendNotificationAtPublish",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Store",
                    "kind": "LinkedField",
                    "name": "receiverStores",
                    "plural": true,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OrgTopic",
                    "kind": "LinkedField",
                    "name": "topic",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "WorkspaceEntity",
                "abstractKey": "__isWorkspaceEntity"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ca1ba15c73deba2cedcd8e79cf1fdf38",
    "id": null,
    "metadata": {},
    "name": "WorkspaceSignalEditMainQuery",
    "operationKind": "query",
    "text": "query WorkspaceSignalEditMainQuery(\n  $id: ID!\n  $workspaceId: ID!\n  $createIfNotExist: Boolean!\n) {\n  organisation {\n    features\n    id\n  }\n  workspace(id: $workspaceId) {\n    id\n    ...SignalWorkspaceTemplateSelector_workspace\n    signal(id: $id, createIfNotExist: $createIfNotExist) {\n      id\n      receiverStores {\n        id\n      }\n      potentialReceiverStores {\n        __typename\n        id\n      }\n      scheduledPublishAt {\n        ...FormattedDate\n      }\n      status\n      ...SignalWorkspaceTemplateSelector_SignalWorkspace\n      ...WorkspaceSignalEditMainPrioritySelector_Signal\n      ...WorkspaceSignalEditMainEditedInfo_Signal\n      ...WorkspaceSignalEditMainContent_Signal\n      ...WorkspaceSignalEditMainProducts_Signal\n      ...WorkspaceSignalEditMainPushNotification_signalWorkspace\n      ...WorkspaceRecieversListItemButton_workspaceEntity\n    }\n  }\n}\n\nfragment FileIcon_File on File {\n  type\n  isOrg\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment LinkedContentInput_files on File {\n  ...LinkedContent_files\n}\n\nfragment LinkedContentInput_images on Image {\n  ...LinkedContent_images\n}\n\nfragment LinkedContent_files on File {\n  id\n  name\n  type\n  url\n  ...LinkedFileItem_file\n}\n\nfragment LinkedContent_images on Image {\n  id\n  sizes {\n    height\n    width\n    id\n  }\n  ...Image_image\n  ...LinkedImageItem_image\n}\n\nfragment LinkedFileItem_file on File {\n  id\n  name\n  ...FileIcon_File\n  pages {\n    id\n  }\n  thumbnail {\n    id\n    ...Image_image\n  }\n}\n\nfragment LinkedImageItem_image on Image {\n  id\n  ...Image_image\n}\n\nfragment LinkedWorkspaceProductItem_WorkspaceProduct on WorkspaceProduct {\n  id\n  imageUrl\n  partNumber\n  name\n}\n\nfragment SignalWorkspaceTemplateSelectorTemplateItem_SignalWorkspaceTemplate on SignalWorkspaceTemplate {\n  id\n  name\n}\n\nfragment SignalWorkspaceTemplateSelector_SignalWorkspace on SignalWorkspace {\n  id\n  updatedBy {\n    __typename\n    id\n  }\n  body\n  title\n  descriptionFiles {\n    __typename\n    id\n  }\n  descriptionImages {\n    __typename\n    id\n  }\n  template {\n    id\n    name\n    ...SignalWorkspaceTemplateSelectorTemplateItem_SignalWorkspaceTemplate\n  }\n}\n\nfragment SignalWorkspaceTemplateSelector_workspace on Workspace {\n  id\n  signalTemplates {\n    id\n    ...SignalWorkspaceTemplateSelectorTemplateItem_SignalWorkspaceTemplate\n  }\n}\n\nfragment WorkspaceRecieversListItemButton_workspaceEntity on WorkspaceEntity {\n  __isWorkspaceEntity: __typename\n  potentialReceiverStores {\n    __typename\n    id\n  }\n  receiverStores {\n    __typename\n    id\n  }\n  topic {\n    name\n    id\n  }\n}\n\nfragment WorkspaceSignalEditMainContent_Signal on SignalWorkspace {\n  id\n  title\n  body\n  formattedBody\n  updatedBySessionId\n  ...WorkspaceSignalLinkedContent_signal\n}\n\nfragment WorkspaceSignalEditMainEditedInfo_Signal on SignalWorkspace {\n  updatedBy {\n    id\n    name\n  }\n  updatedAtDate {\n    ...FormattedDate\n  }\n}\n\nfragment WorkspaceSignalEditMainPrioritySelector_Signal on SignalWorkspace {\n  id\n  priority\n  updatedAtDate {\n    ...FormattedDate\n    isoString\n  }\n  updatedBy {\n    name\n    id\n  }\n}\n\nfragment WorkspaceSignalEditMainProducts_Signal on SignalWorkspace {\n  id\n  linkedProducts {\n    id\n    ...LinkedWorkspaceProductItem_WorkspaceProduct\n  }\n}\n\nfragment WorkspaceSignalEditMainPushNotification_signalWorkspace on SignalWorkspace {\n  id\n  sendNotificationAtPublish\n  updatedAtDate {\n    isoString\n    ...FormattedDate\n  }\n  updatedBy {\n    name\n    id\n  }\n}\n\nfragment WorkspaceSignalLinkedContent_signal on SignalWorkspace {\n  id\n  descriptionImages {\n    id\n    ...LinkedContentInput_images\n  }\n  descriptionFiles {\n    id\n    url\n    name\n    type\n    ...LinkedContentInput_files\n  }\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "7ad910b837e7f60525f8b6b2a6d017d2";

export default node;
